import BaseAvatar from '@/components/bases/BaseAvatar';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import React from 'react';

interface Props {
  user?: IUser;
  showDrawer(): void;
  listMember?: any;
  isMainUser?: boolean;
}

const PHRMobileInfo = ({ user, listMember = [], showDrawer, isMainUser }: Props) => {
  const relationObj = listMember?.find((m: any) => m._id === user?._id);
  const relation = isMainUser ? 'Chủ tài khoản' : relationObj?.dependent?.relation?.dependent ?? '';

  return (
    <button
      onClick={showDrawer}
      className="flex flex-row w-[100vw] items-center justify-between bg-mint-9 pr-6 pl-6 pt-2 pb-4 mt-0"
    >
      <BaseAvatar
        username={user?.username ?? ''}
        src={user?.avatar ?? 'images/UserPortraits/avatar.png'}
        className="w-9 h-9"
      />
      <div className="flex flex-1 mr-4 ml-4 text-white flex-col items-start">
        <span className="label-large">{user?.username ?? ''}</span>
        <span className="cms-body2">{relation}</span>
      </div>
      <BaseIconSvg src="/icons/Regular/Angle Down - icon.svg" className="text-white" />
    </button>
  );
};

export default PHRMobileInfo;
